export const auth = {
  login: "accounts/login/admin/",
  logout: "accounts/logout/",
  check_token: "accounts/check/token/",
};
